import React from "react";
import Styles from './styles.module.scss';

const ProgressBar = ({ current, total }) => {
    const percentage = Math.min((current / total) * 100, 100).toFixed(2);

    return (
        <div className={Styles.wrapper}>
            <div className={Styles.progressOuter}>
                <div className={Styles.progressInner} style={{ width: `${percentage}%` }}></div>
            </div>
        </div>
    );
};

export default ProgressBar;